import { api } from '@/api'
import { ICurrentUser } from '@/interfaces/User'
import { useStoreon } from 'storeon/react'

const useCurrentUser = (): {
  currentUser: ICurrentUser
  isLogin: boolean
  isLoaded: boolean
  reRoadUser: () => void
  logout: () => void
} => {
  const { currentUser, dispatch } = useStoreon('currentUser')
  const isLoaded = currentUser !== null
  const isLogin = isLoaded && currentUser.status === true

  const reRoadUser = (): void => {
    dispatch('user/get', {
      callback: () => { }
    })
  }

  const logout = async (): Promise<void> => {
    await api.logout()
    window.location.href = '/'
  }

  return {
    isLoaded,
    isLogin,
    currentUser,
    reRoadUser,
    logout
  }
}

export default useCurrentUser
